<template>
  <span>
    <v-btn @click="dialog = !dialog" color="green" dark>Tạo phiếu sửa chữa</v-btn>
    <v-dialog max-width="80%" v-model="dialog">
      <app-card>
        <h4>TẠO PHIẾU SỬA CHỮA</h4>
        <p class="fs-14 grey--text">Tạo phiếu sửa chữa mới</p>
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-menu :close-on-content-click="false" v-model="menu_registration_date" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field slot="activator" v-model="form.registration_date" label="Ngày tạo phiếu"
                    :disabled="loading.submit" prepend-icon="event" readonly :rules="[rules.required]"></v-text-field>
                  <v-date-picker locale="vi-VI" v-model="form.registration_date"
                    @input="menu_registration_date = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md3>
                <v-select label="Tòa nhà" :disabled="loading.submit" v-model="form.building" :items="list_building"
                  prepend-icon="domain" :rules="[rules.required]
                    " @change="form.room_id = ''" required></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field label="Số chứng từ giấy" v-model="form.receipt_code"
                  :disabled="loading.submit"></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field label="Mã chứng từ" v-model="form.receipt_id" disabled></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-autocomplete label="Số phòng" :disabled="loading.submit" v-model="form.room_id" :items="room_ids"
                  item-text="room_id" item-value="rooms_id" prepend-icon="meeting_room" :rules="[rules.required]"
                  required></v-autocomplete>
              </v-flex>
              <v-flex v-if="form.room_id === 'Khác'" xs12 md3>
                <v-text-field v-model="form.customRoomId" label="Nhập số phòng" :rules="[rules.required]"
                  required></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-select label="Thợ sửa chữa" :disabled="loading.submit" v-model="form.repairman_name" 
                  :items="repairmen_name" prepend-icon="person_pin"></v-select>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu :close-on-content-click="false" v-model="menu_scheduled_date" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field slot="activator" v-model="form.scheduled_date" label="Ngày hẹn sửa"
                    :disabled="loading.submit" prepend-icon="event" readonly></v-text-field>
                  <v-date-picker locale="vi-VI" v-model="form.scheduled_date"
                    @input="menu_scheduled_date = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Nội dung yêu cầu" v-model="form.content" prepend-icon="event_note"
                  :disabled="loading.submit" :rules="[rules.required]" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loading.submit" :disabled="loading.submit || alert.show" @click="submit" color="green"
              class="white--text">
              Tạo Phiếu
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-card>
    </v-dialog>
  </span>
</template>

<script>
import api from "Api";
import { Wallet } from "Components/Form";
import {
  list_building, REPAIR_REQUEST_STATUS
} from "Constants/db-config";

export default {
  name: "dialog-tao-phieu-sua-chua",
  props: {
    repairmen_name: Array
  },
  components: {
    Wallet,
  },
  data() {
    return {
      dialog: false,
      menu_registration_date: false,
      menu_scheduled_date: false,
      loading: {
        submit: false,
      },
      form: {
        registration_date: "",
        building: "",
        receipt_code: "",
        receipt_id: "",
        room_id: "",
        content: "",
        customRoomId: "",
        repairman_name: "",
        scheduled_date: ""
      },
      list_building,
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      REPAIR_REQUEST_STATUS
    };
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    room_ids() {
      return ["Khác", ...this.rooms.filter((room) => room.building === this.form.building)];
    },
  },
  watch: {
    "form.receipt_code"(nv) {
      if (nv && this.form.building) {
        const buildingCode = this.form.building === 'MT' ? 'MA' : this.form.building;
        this.form.receipt_id = buildingCode + '.' + nv + ".SC";
      }
    },
    "form.building"(nv) {
      if (nv && this.form.receipt_code) {
        const buildingCode = nv === 'MT' ? 'MA' : nv;
        this.form.receipt_id = buildingCode + '.' + this.form.receipt_code + ".SC";
      }
    }
  },
  methods: {
    clearInput: function () {
      this.$refs.form.reset();
    },
    submit: async function () {
      if (!this.$refs.form.validate()) {
        swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
        return;
      }
      const postData = {
        ...this.form,
        room_id: this.form.room_id === "Khác" ? this.form.customRoomId : this.form.room_id,
        status: this.REPAIR_REQUEST_STATUS.CHUA_SUA
      };

      this.loading.submit = true;
      const data = await api.createRepairReceipt(postData);
      this.loading.submit = false;
      if (data.status === 200) {
        this.dialog = false;
        swal.fire("Thành công", data.data.message, "success");
        this.$emit("reloadTable");
        this.clearInput();
      } else {
        swal.fire("Lỗi", data.message, "error");
      }
    },
  },
};
</script>

<style></style>
